import { render, staticRenderFns } from "./scrolldowns.vue?vue&type=template&id=55332456&scoped=true"
import script from "./scrolldowns.vue?vue&type=script&lang=js"
export * from "./scrolldowns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55332456",
  null
  
)

export default component.exports